import React, { createContext, ReactNode, useContext, useState } from 'react';
import {
  HandlersAttachmentResponse,
  HandlersDeliverableCreateRequest,
} from '../../../../app/athenaApiGen';
import { createEmptyDeliverable } from '../../consts';

// Snapshot of the workflow at edit-modal-open time. Used by StepperContent to
// decide whether to flip workflow back to Pending before applying an update
// (backend rejects updates on non-Pending workflows). Null on Create flow.
type TWorkflowInfo = {
  workflowId?: string | null;
  workflowState?: string | null;
} | null;

type TDeliverableModalContext = {
  deliverable: HandlersDeliverableCreateRequest;
  uploadedFiles: File[];
  setUploadedFiles: React.Dispatch<React.SetStateAction<File[]>>;
  savedFiles: HandlersAttachmentResponse[];
  setSavedFiles: React.Dispatch<
    React.SetStateAction<HandlersAttachmentResponse[]>
  >;
  setDeliverable: React.Dispatch<
    React.SetStateAction<HandlersDeliverableCreateRequest>
  >;
  originalWorkflow: TWorkflowInfo;
  setOriginalWorkflow: React.Dispatch<React.SetStateAction<TWorkflowInfo>>;
};

const DeliverableModalContext = createContext<
  TDeliverableModalContext | undefined
>(undefined);

const DeliverableModalProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [deliverable, setDeliverable] =
    useState<HandlersDeliverableCreateRequest>(createEmptyDeliverable);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [savedFiles, setSavedFiles] = useState<HandlersAttachmentResponse[]>(
    [],
  );
  const [originalWorkflow, setOriginalWorkflow] = useState<TWorkflowInfo>(null);

  const contextValue = {
    deliverable,
    setDeliverable,
    uploadedFiles,
    setUploadedFiles,
    savedFiles,
    setSavedFiles,
    originalWorkflow,
    setOriginalWorkflow,
  };

  return (
    <DeliverableModalContext.Provider value={contextValue}>
      {children}
    </DeliverableModalContext.Provider>
  );
};

const useDeliverableModalContext = () => {
  const context = useContext(DeliverableModalContext);
  if (context === undefined) {
    throw new Error(
      'useDeliverableModalContexnt must be used within a DeliverableModalProvider',
    );
  }
  return context;
};

export {
  DeliverableModalContext,
  DeliverableModalProvider,
  useDeliverableModalContext,
};
